import React from "react";
import { Styled } from './styled';

interface BlueButtonProps {
  text: string;
  noArrow?: boolean;
}

const BlueButton = (props: BlueButtonProps) => {
  return (
      <Styled.Text>
        {props.text} {!props.noArrow && <Styled.Arrow>→</Styled.Arrow>}
      </Styled.Text>
  )
}

export default BlueButton
